import * as React from 'react'
import styled from 'styled-components'

interface Props {
  icon: any
  children: any
}

export const IconText = (props: Props) => {
  const { icon, children } = props
  return (
    <Container>
      <Icon>
        <img src={icon} alt='icon' />
      </Icon>
      <p>{children}</p>
    </Container>
  )
}

const Container = styled.div`
  display: inline-block;
  max-width: 180px;
  p {
    text-align: center;
    line-height: 1.2;
    a {
      color: #4a4a4a;
    }
  }
`

const Icon = styled.div`
  width: 60px;
  height: 60px;
  margin: 7.5px auto 10px auto;
  padding: 15px;
  border-radius: 100%;
  box-shadow: 1px 2px 4px #a4a4a4;
  background-color: #a7c9cd;
  img {
    width: 100%;
    margin: auto;
  }
`

export default IconText



// WEBPACK FOOTER //
// ./src/components/atoms/IconText.tsx